"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const milestones = [{
  year: "2012",
  title: "The Inception",
  desc: "Lavers Business Consulting was founded in Latrobe with a singular mission: to bring enterprise-level efficiency to local Australian businesses.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lg_foundation_2005.png"
}, {
  year: "2015",
  title: "Efficiency Frameworks",
  desc: "Developed our proprietary lean methodology, helping SMEs reduce operational waste and streamline complex internal workflows.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lg_construction_2012.png"
}, {
  year: "2018",
  title: "Strategic Expansion",
  desc: "Scaled our services to include comprehensive cost-reduction audits, delivering significant bottom-line improvements for mid-market firms.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lg_resort_2018.png"
}, {
  year: "2021",
  title: "Revenue Optimization",
  desc: "Launched our growth-focused consulting arm, integrating data analytics to identify untapped revenue streams for our diverse clientele.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lg_fitness_2022.png"
}, {
  year: "2024",
  title: "A Decade of Impact",
  desc: "Celebrating over ten years of driving measurable ROI and business transformation across Australia through precision and expertise.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lg_project_2024.png"
}];
function TimelineItem({
  milestone,
  index
}: {
  milestone: (typeof milestones)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.4,
    once: false
  });
  return <div data-section-id="119149" ref={ref} data-index={index} className={`relative pl-12 md:pl-0 md:flex md:flex-row md:items-center w-full mb-32 last:mb-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-20 translate-y-16 scale-[0.98]"}`}>
      {}
      <div className={`absolute left-[11px] md:left-1/2 w-5 h-5 rounded-full border-4 border-background transform -translate-x-1/2 top-3 md:top-auto transition-colors duration-700 z-10 shadow-sm ${isVisible ? "bg-primary" : "bg-muted-foreground/30"}`} />

      {}
      <div className="md:w-1/2 md:flex md:justify-end md:pr-20 mb-8 md:mb-0">
        <h3 className={`text-6xl md:text-8xl font-sans font-bold tracking-tighter transition-colors duration-700 ${isVisible ? "text-foreground" : "text-muted-foreground/50"}`}>
          {milestone.year}
        </h3>
      </div>

      {}
      <div className="md:w-1/2 md:pl-20">
        <Card className="overflow-hidden border border-border shadow-none bg-card/50 backdrop-blur-sm rounded-sm transition-transform duration-700 hover:-translate-y-2">
          <div className="relative h-64 md:h-80 overflow-hidden">
            <div className="absolute inset-0 bg-emerald-500/10 z-10" />
            <img src={milestone.img} alt={milestone.title} className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105 grayscale hover:grayscale-0" />
          </div>
          <CardContent className="p-8 md:p-10">
            <h4 className="text-2xl md:text-3xl font-bold mb-4 font-sans tracking-tight">
              {milestone.title}
            </h4>
            <p className="text-muted-foreground text-xl leading-relaxed">
              {milestone.desc}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>;
}
export default function TheLgJourney() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="a-decade-of-impact" className="relative py-24 md:py-40 bg-background overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-64 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        <div ref={headerRef} className={`text-center mb-24 md:mb-40 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-sm font-bold tracking-widest text-emerald-600 uppercase mb-4 font-mono">
            Our History
          </h2>
          <h3 className="text-4xl md:text-6xl font-sans font-bold tracking-tight text-foreground">
            A Decade of Impact
          </h3>
        </div>

        <div className="relative">
          {}
          <div className="absolute left-[11px] md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-transparent via-primary/20 to-transparent transform -translate-x-1/2" />

          {}
          <div className="relative z-10">
            {milestones.map((milestone, index) => <TimelineItem key={milestone.year} milestone={milestone} index={index} />)}
          </div>
        </div>
      </div>
    </section>;
}